'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setStripeKey = undefined;

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stripe_key = null;

var stripeUrl = function stripeUrl(path) {
  return 'https://api.stripe.com/v3/' + path;
};

var stripeBody = function stripeBody(body) {
  return Object.keys(body).map(function (key) {
    var property = encodeURIComponent(key);
    return 'card[' + property + ']=' + encodeURIComponent(body[key]);
  }).join('&');
};

var stripeError = function stripeError(error) {
  var errors = {
    'invalid_number': _i18next2.default.t('lib.stripe_invalid_number'),
    'invalid_expiry_month': _i18next2.default.t('lib.stripe_invalid_expiry_month'),
    'invalid_expiry_year': _i18next2.default.t('lib.stripe_invalid_expiry_year'),
    'invalid_cvc': _i18next2.default.t('lib.stripe_invalid_cvc'),
    'incorrect_number': _i18next2.default.t('lib.stripe_invalid_number'),
    'expired_card': _i18next2.default.t('lib.stripe_expired_card'),
    'incorrect_cvc': _i18next2.default.t('lib.stripe_invalid_cvc'),
    'incorrect_zip': _i18next2.default.t('lib.stripe_incorrect_zip'),
    'card_declined': _i18next2.default.t('lib.stripe_card_declined'),
    'missing': _i18next2.default.t('lib.stripe_missing'),
    'processing_error': _i18next2.default.t('lib.stripe_processing_error')
  };

  var message = errors[error.code] || errors['processing_error'];
  return [{ message: message }];
};

var setStripeKey = exports.setStripeKey = function setStripeKey(key) {
  return stripe_key = key;
};

exports.default = {
  stripeCreateCardToken: function stripeCreateCardToken(deliveryAction, card) {
    var url = stripeUrl('tokens');
    var encodedBody = stripeBody({
      number: card.number,
      exp_month: card.expiryMonth,
      exp_year: card.expiryYear,
      cvc: card.cvv
    });

    var options = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Bearer ' + stripe_key
      },
      body: encodedBody
    };

    return fetch(url, options).then(function (res) {
      return res.json();
    }).then(function (result) {
      if (result.error) {
        return deliveryAction.createCardTokenFailure(stripeError(result.error), { error: result.error });
      }

      deliveryAction.createCardTokenSuccess(result.id);

      return result.id;
    }).catch(function (error) {
      deliveryAction.createCardTokenFailure(stripeError({ type: 'processing_error' }), { error: error });
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/~/@arreeba/ristoranti-lib/lib/payment.js
// module id = 424
// module chunks = 0